@if (isFrench) {
  <div class="currency-selector">
    <span class="currency-label">{{'PRODUCTS.CURRENCY' | translate}}</span>
    <div class="currency-pills">
      <button class="currency-pill"
        [class.active]="currentCurrency === 'EUR'"
        (click)="onCurrencyChange('EUR')">
        € EUR
      </button>
      <button class="currency-pill"
        [class.active]="currentCurrency === 'XAF'"
        (click)="onCurrencyChange('XAF')">
        FCFA
      </button>
    </div>
  </div>
}
